module.exports = __webpack_public_path__ + "static/img/A-android.47f8213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/A-android.png
// module id = VCez
// module chunks = 1